<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <month-picker v-model="month" label="Select Month"></month-picker>
      <v-spacer />

      <div class="d-flex">
        <v-btn
          @click="printReport"
          class="elevation-0"
          color="primary"
          outlined
          elevation="2"
        >
          <v-icon left> mdi-printer</v-icon>
          Print</v-btn
        >
      </div>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="textMessageViews"
      :items-per-page="10"
      :loading="loading"
    ></v-data-table>
  </v-card>
</template>

<script>
import { axios, Strings } from '../../../utils'
import MonthPicker from '../../../components/MonthPicker'
import moment from 'moment'

export default {
  components: {
    MonthPicker
  },
  data() {
    return {
      loading: false,

      headers: [
        {
          text: 'Customer Name',
          align: 'start',
          sortable: true,
          value: 'customer'
        },
        {
          text: 'Listing type',
          align: 'start',
          sortable: true,
          value: 'type'
        },
        {
          text: 'Business Name',
          align: 'start',
          sortable: true,
          value: 'businesses'
        },
        {
          text: 'Sent at',
          align: 'start',
          sortable: true,
          value: 'time'
        },
        {
          text: 'No. of sms sent',
          align: 'start',
          sortable: true,
          value: 'sms'
        }
      ],
      textMessageViews: [],
      month: ''
    }
  },
  mounted() {
    this.getTextMessageViews()
  },
  methods: {
    getTextMessageViews() {
      this.loading = true
      axios
        .get(
          `/api/admin/get-text-message-views?month=${
            this.month ? this.month : new Date().toISOString().substr(0, 7)
          }`
        )
        .then(res => {
          let modifiedEntries = []
          console.log(res.data)

          res.data.map(item => {
            let businessesDetail = item.clients.concat(
              item.priority_listings,
              item.free_listings
            ) //array of all the businesses

            let entry = {}
            businessesDetail.map(business => {
              let buinessName =
                'name' in business ? business.name : business.business_name
              entry = {
                customer: item.quote.name,
                type: business.pivot.messageable_type.substr(11), //
                businesses: buinessName,
                time: moment(String(item.quote.created_at)).format(
                  'MMMM Do YYYY, h:mm a'
                ),
                sms: this.countOccurences(modifiedEntries, buinessName) //count of business in businessDetail array
              }

              modifiedEntries.push(entry)
            })
          })

          this.textMessageViews = modifiedEntries
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    countOccurences(array, business) {
      let occurences = 1
      array.map(item => {
        if (item.businesses === business) {
          occurences += 1
        }
      })
      array.map(item => {
        if (item.businesses === business) {
          item.sms = occurences
        }
      })
      return occurences
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=message&name=MESSAGES REPORT`,
        '_blank'
      )
    }
  },
  watch: {
    month: function() {
      this.getTextMessageViews()
    }
  }
}
</script>

<style lang="scss" scoped></style>
